import { Button } from "primereact/button";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import appActions from "../../../appActions";
import { TabPanel, TabView } from "primereact/tabview";

const Dashboard = () => {

    const dispatch = useDispatch();

    const fileGroupStats = useSelector((state) => state.dashboard.fileGroupStats);
    const filePjoStats = useSelector((state) => state.dashboard.pjoStats);

    const [activeIndex, setActiveIndex] = useState(0);


    const [lastSynceDateTime, setLastSynceDateTime] = useState(null);
    
    const defaultParams = useMemo(() => ({
        templateTypes: "PJO,FGPT,FGPM,IPRT,CPNT,CBT,MCT,EIT,ITT,RECT,ILT,FGM,MSM,PJOA,PJOC"
    }), []);

    useEffect(() => {
        dispatch(appActions.DASHBOARD_GET_STATS_REQUEST(defaultParams));
        dispatch(appActions.DASHBOARD_GET_PJO_STATS_REQUEST());
        setLastSynceDateTime(new Date().toISOString()); // Set last sync time
    }, [dispatch, defaultParams]);

    const getFileState = useCallback(() => {
        dispatch(appActions.DASHBOARD_GET_STATS_REQUEST(defaultParams));
        setLastSynceDateTime(new Date().toISOString()); // Set last sync time
    }, [dispatch, defaultParams]);

    const getPjoState = useCallback(() => {
        dispatch(appActions.DASHBOARD_GET_PJO_STATS_REQUEST());
        setLastSynceDateTime(new Date().toISOString()); // Set last sync time
    }, [dispatch]);

    const handleRefresh = () => {
        getFileState()
        getPjoState()
    };

    const renderHeader = () => (
         <div className="flex flex-row gap-10 align-items-center">
            <h1 className="text-xl font-bold">Dashboard</h1>
            <Button icon="pi pi-sync" className="p-button-rounded p-button-text mr-auto" onClick={handleRefresh} />
            <small className="text-sm text-gray-500 f-right "><strong>Last template received: </strong> {lastSynceDateTime}</small>
        </div>
    );

    const renderCards = () => (
        <div className="grid">
            { filePjoStats && fileGroupStats?.map((group, index) => (
                <div key={index} className="col-6">
                    <div className=" bg-white shadow-white pv-15 ph-15 mb-2">

                    <h2 className="text-lg font-semibold">{group?.fileGroup} {group?.lastCreatedDate &&  <small className="text-sm text-gray-500 f-right"> <strong>Last template received: </strong> {group?.lastCreatedDate}</small> }</h2>
            
                    <div className="flex flex-row gap-10 fill-flex">
                        
                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.totalCount}</h1>
                            <h5 className="stats-title">Total Count</h5>
                        </div>

                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.receivedCount}</h1>
                            <h5 className="stats-title">Received</h5>
                        </div>

                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.convertedCount}</h1>
                            <h5 className="stats-title">Converted</h5>
                        </div>

                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.uploadedCount}</h1>
                            <h5 className="stats-title">Uploaded</h5>
                        </div>

                        <div className={`flex flex-column justify-content-start stats-wrapper ${group?.error === 'Y' ? 'error-class' : ''}`}>

                            <h1 className="stats-count">{group?.errorCount}</h1>
                            <h5 className="stats-title">Errors</h5>
                        </div>
                        </div>
                     </div>
                    
                </div>
            ))}
        </div>
    );

    const renderPjoCards = () => (
        <div className="grid">
            {filePjoStats  && filePjoStats?.map((group, index) => (
                <div key={index} className="col-12">
                    <div className=" bg-white shadow-white pv-15 ph-15 mb-2">

                        <h2 className="text-lg font-semibold">Store Id: {group?.storeId} {group?.lastCreatedDate &&  <small className="text-sm text-gray-500 f-right"> <strong>Last template received: </strong> {group?.lastCreatedDate}</small> }</h2>
                
                        <div className="flex flex-row gap-10 fill-flex">
                            
                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.count}</h1>
                                <h5 className="stats-title">Total Count</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.pjoxmlStatusY}</h1>
                                <h5 className="stats-title">PJO XML Status Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.pjoxmlStatusN}</h1>
                                <h5 className="stats-title">PJO XML Status No</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.eodxmlStatusY}</h1>
                                <h5 className="stats-title">EOD XML Status Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.eodxmlStatusN}</h1>
                                <h5 className="stats-title">PJO XML Status No</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.tlogExtApiErrorY}</h1>
                                <h5 className="stats-title">Tlog Ext API Error Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.tlogExtApiErrorN}</h1>
                                <h5 className="stats-title">Tlog Ext API Error No</h5>
                            </div>

                             <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.errorY}</h1>
                                <h5 className="stats-title">Error Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.errorN}</h1>
                                <h5 className="stats-title">Error No</h5>
                            </div>

                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
      <div className="form_height">
            <div className='pv-15 ph-15'>
                    {renderHeader()}
            </div>
            <div className="mx-3 br-6s">
                <TabView activeIndex={activeIndex} onTabChange={(e) => { e.index === 0 ? getFileState() : getPjoState(); setActiveIndex(e.index) }}>
                    <TabPanel header="Integration File Stats" leftIcon="pi pi-file mr-2">
                        {renderCards()}    
                    </TabPanel>    
                    <TabPanel header="POS Journal File Stats" leftIcon="pi pi-shopping-bag mr-2">
                        {renderPjoCards()}    
                    </TabPanel>    
                </TabView>
            </div>

        </div>
    );
};

export default Dashboard;